import React from "react";

const baseApiUrl = global.config.baseApiUrl;
const baseSsoUrl = global.config.baseSsoUrl;

/**
 * @typedef SSOLoginProps
 * @property {function} authCallback    Callback function when authentication is complete. 
 *                                      called with err and authData
 */
/**
 * 
 * @param {SSOLoginProps} props 
 * @returns 
 */
const SSOLogin = (props) => {
    let childWindow;

    const onMessage = (event)=>{
        if(!baseSsoUrl.startsWith(event.origin)){
            throw new Error('Invalid event origin - ' + event.origin);
        }else if(!event.isTrusted){
            throw new Error('Untrusted event');
        }

        window.removeEventListener('message', onMessage);
        if(event.source) event.source.close();

        let authData;
        let err;
        try{
            authData = JSON.parse(decodeURIComponent(event.data));
        }catch(e){
            err="Unable to parse event data";
        }
        props.authCallback(err, authData);

    }
    const handleClick = ()=>{
        const protocol = window.location.protocol || "https:";
        const host = window.location.host;
        const baseLoginUrl = "/login";
        //encoding relayState in prep for supporting IdP initiated session
        const relayState = encodeURIComponent('message');//`${protocol}//${host}${baseLoginUrl}`
        //window.location.href = `${baseSsoUrl}?RelayState=${encodeURIComponent(relayStateUrl)}`;
        childWindow = window.open(`${baseSsoUrl}?RelayState=${relayState}`, "sso", "width=800;height=600");
        window.addEventListener("message", onMessage);
    }

    return (
        <div className="d-flex justify-content-center">
            <button type="button" className="btn btn-block standard-btn" style={{ width: '160px' }} onClick={handleClick}>
                Single Sign On
            </button>
        </div>
    );
}

export default SSOLogin;